import React, { FC, useContext } from "react";
import Box from "@mui/material/Box";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { IProject } from "common/store/UserStore";
import { LanguageContext } from "common/contexts/LanguageContext";

interface HeadCell {
    disablePadding: boolean;
    id: keyof IProject | "actions";
    label: string;
    numeric: boolean;
  }
  
  export type Order = "asc" | "desc";

  interface ProjectTableProps {
    onRequestSort: (
      event: React.MouseEvent<unknown>,
      property: keyof IProject
    ) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
  }
  
  const ProjectTableHead: FC<ProjectTableProps> = (props) => {
    const { order, orderBy, onRequestSort } = props;
    const { getString } = useContext(LanguageContext);
    
    const nameColumnStyle = { width: "35%" };
    const actionsColumnStyle = { width: "30px" };
    
      const headCells: readonly HeadCell[] = [
      {
        id: "projectName",
        numeric: false,
        disablePadding: true,
        label: getString('tbl_hdr_proj_name'),
      },
      {
        id: "owner",
        numeric: false,
        disablePadding: false,
        label: getString('tbl_hdr_proj_owner'),
      },
      {
        id: "networkCount",
        numeric: true,
        disablePadding: false,
        label: getString('tbl_hdr_proj_nwk_count'),
      },
      {
        id: "updatedDate",
        numeric: true,
        disablePadding: false,
        label: getString('tbl_hdr_proj_update_date'),
      },
      {
        id: "createdDate",
        numeric: true,
        disablePadding: false,
        label: getString('tbl_hdr_proj_create_date'),
      },
      {
        id: "actions",
        numeric: false,
        disablePadding: false,
        label: "",
      },
    ];
    
      const createSortHandler =
      (property: keyof IProject | "actions") =>
      (event: React.MouseEvent<unknown>) => {
        if (property !== "actions") {
          onRequestSort(event, property);
        }
      };
  
    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.id === "projectName" ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              style={
                headCell.id === "projectName"
                  ? nameColumnStyle
                  : headCell.id === "actions"
                    ? actionsColumnStyle
                    : undefined
              }
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                sx={{ fontWeight: "bold" }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  export default ProjectTableHead;
